<template>
  <page>
    <page
      :custom-style="{
        paddingBottom: showBottom ? '60px' : '0',
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
        boxSizing: 'border-box'
      }"
    >
      <div class="page-panel">
        <div v-if="topMsg" class="rule-wrapper">
          <div class="title">活动规则</div>
          <div class="activity-content">
            {{ topMsg }}
          </div>
        </div>
        <div v-if="goodList.length" class="good-list">
          <GoodItem
            v-for="(item, index) in goodList"
            :key="index"
            class="good-card"
            :sku="item"
            :sku-index="index"
            :can-change-price="canChangePrice"
            :change-ssuid="changeSsuid"
            :join-ssu-ids="joinSsuIds"
            @changeSsu="changePriceSsu"
          />
        </div>

        <empty
          v-else
          :desc="'当前没有适合您的活动，请耐心等待'"
          :type="1"
          :img="'Empty'"
          class="empty-box"
        ></empty>
      </div>
    </page>
    <div v-if="showBottom" class="bottom-panel">
      <div v-if="canChangePrice" class="change-price" @click="changePrice">
        改价
      </div>
      <div v-else class="bottom-msg">{{ buttonMsg }}</div>
    </div>
  </page>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import GoodItem from './goodItem.vue'
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
import { APP_CONFIG } from '@/defines/environment/config'

export default {
  components: {
    GoodItem,
    Empty
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const pageTitle = `${APP_CONFIG.app_short_name}价格您做主`
      navBar.setTitle({
        text: pageTitle
      })
      document.title = pageTitle

      vm.getMCPriceSsu(true)
    })
  },
  data() {
    return {
      goodList: [],
      topMsg: '',
      buttonMsg: '',
      joinSsuIds: [],
      changeSsuid: '',
      batchId: '',
      tracerParams: {}
    }
  },
  computed: {
    canChangePrice() {
      return this.goodList.length && !this.joinSsuIds.length
    },
    showBottomMsg() {
      return this.goodList.length && !!this.buttonMsg
    },
    showBottom() {
      return this.canChangePrice || this.showBottomMsg
    }
  },
  methods: {
    async getMCPriceSsu(showLoading) {
      if (showLoading) {
        this.$Loading()
      }

      try {
        const res = await API.cms.getMCPriceSsu()
        console.log('res', res)
        this.goodList = res?.baseSsuInfoBySsuIds || []
        this.topMsg = res?.topMsg || ''
        this.buttonMsg = res?.buttonMsg || ''
        this.batchId = res?.batchId || ''
        this.joinSsuIds = res?.joinSsuIds || []
      } catch (error) {
        this.topMsg = ''
        this.buttonMsg = ''
        this.batchId = ''
        this.joinSsuIds = []
      }
      this.$Loading.hide()
    },
    async changePrice() {
      if (!this.changeSsuid) {
        return this.$toast('请选择改价商品')
      }
      const spm = this.$trackMap.userChangePrice.changeBtnClick
      this.$track(spm, this.tracerParams)
      try {
        const params = {
          batchId: this.batchId,
          ssuId: this.changeSsuid
        }
        const res = await API.cms.applyCreateActivity(params)
        this.$toast({
          message: res.msg || '改价成功'
        })
        this.getMCPriceSsu()
      } catch (error) {
        this.$catch(error)
      }
    },
    changePriceSsu(ssuId, tracerParams) {
      this.changeSsuid = ssuId
      this.tracerParams = tracerParams
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 500;
  padding: 0.08rem /* 4/50 */ 0.32rem /* 16/50 */;

  width: 100%;

  background-color: #f5f5f5;
  box-sizing: border-box;

  @include flex-row-between;
  @include iphonex-fixed-bottom(4px, #f5f5f5);

  .change-price {
    width: 100%;
    height: 0.96rem /* 48/50 */;
    background-color: #15bb5c;

    border-radius: 0.52rem /* 26/50 */;
    @include flex-row-center;
    @include text(0.32rem /* 16/50 */, #fff, true);
  }
  .bottom-msg {
    width: 100%;
    height: 0.96rem /* 48/50 */;

    @include flex-row-center;
    @include text(0.24rem /* 12/50 */, #262626);
  }
}
.page-panel {
  padding: 0.32rem /* 16/50 */ 0.24rem /* 12/50 */;
  .rule-wrapper {
    padding: 0.24rem /* 12/50 */;

    background-color: #fff;

    border-radius: 0.24rem /* 12/50 */;
    .title {
      @include text(0.32rem /* 16/50 */, #262626, true);
    }
    .activity-content {
      margin-top: 0.2rem /* 10/50 */;
      line-height: 15px;
      white-space: pre-wrap;
      @include text(0.24rem /* 12/50 */, #262626);
    }
  }
  .good-list {
    margin-top: 16px;

    background-color: #fff;

    border-radius: 0.24rem /* 12/50 */;
  }
}
</style>
